module.exports = __webpack_public_path__ + "static/media/logo2_x3_text.e5a8e05b.png";